import styled from 'styled-components';
import { media, CalendarField } from './StyledCalendarBase';

// Estilos específicos para modales y formularios
export const CalendarModalCard = styled.div`
    position: relative;
    background: #FFFFFF;
    border-radius: 18px;
    box-shadow: 0px 20px 40px rgba(15, 23, 42, 0.22);
    padding: 28px 26px;
    width: 100%;
    max-width: 520px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 18px;
    
    ${media.tablet} {
        padding: 24px 20px;
        border-radius: 12px;
        max-width: 480px;
        gap: 16px;
    }
    
    ${media.mobile} {
        padding: 20px 16px;
        border-radius: 8px;
        max-width: 95vw;
        gap: 14px;
        margin: 10px;
    }
`;

export const CalendarFormLayout = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 20px;
    row-gap: 14px;

    ${media.laptop} {
        column-gap: 16px;
        row-gap: 12px;
    }

    ${media.tablet} {
        grid-template-columns: 1fr;
        row-gap: 14px;
    }

    ${media.mobile} {
        row-gap: 12px;
    }

    & > ${CalendarField} {
        min-width: 0;
    }

    & > ${CalendarField}[data-span='full'] {
        grid-column: 1 / -1;
    }
`;

export const CalendarModalCloseButton = styled.button`
    position: absolute;
    top: 16px;
    right: 16px;
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 8px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: hsl(0, 0%, 35%);
    transition: all 0.2s ease;
    z-index: 10;

    &:hover {
        background: hsl(210, 40%, 96%);
        color: hsl(0, 0%, 20%);
    }

    &:focus {
        outline: 2px solid hsl(24, 85%, 60%);
        outline-offset: 2px;
    }
    
    ${media.tablet} {
        top: 12px;
        right: 12px;
        padding: 6px;
    }
    
    ${media.mobile} {
        top: 8px;
        right: 8px;
        padding: 4px;
    }
`;

export const CalendarModalTitle = styled.h2`
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: hsl(0, 0%, 20%);
    
    ${media.tablet} {
        font-size: 18px;
    }
    
    ${media.mobile} {
        font-size: 16px;
    }
`;

export const CalendarModalDescription = styled.p`
    margin: 0;
    font-size: 14px;
    color: hsl(0, 0%, 35%);
    
    ${media.tablet} {
        font-size: 13px;
    }
    
    ${media.mobile} {
        font-size: 12px;
    }
`;

export const CalendarModalActions = styled.div`
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 8px;
    
    ${media.tablet} {
        gap: 10px;
    }
    
    ${media.mobile} {
        gap: 8px;
        flex-direction: column;
        width: 100%;
    }
`;

export const StyledModalDynamic = styled.div`
    position: relative;
    width: auto;
    margin-top: 0;
`;

export const CancelButton = styled.button`
    border: none;
    background-color: hsl(0, 0%, 60%);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    display: flex;
    box-sizing: border-box;
    margin: 20px;
    padding: 10px 15px;
    justify-content: center;
    font-size: 12px;
    align-items: center;
    cursor: pointer;
    margin-left: 8px;
    
    ${media.tablet} {
        margin: 15px;
        padding: 8px 12px;
        font-size: 11px;
        border-radius: 8px;
    }
    
    ${media.mobile} {
        margin: 10px;
        padding: 8px 10px;
        font-size: 10px;
        border-radius: 6px;
        width: 100%;
    }
`;

// Estilos para el buscador de pacientes
export const PatientSearchContainer = styled.div`
    position: relative;
    width: 100%;
`;

export const PatientSearchInput = styled.input`
    width: 100%;
    padding: 10px 14px;
    border: 1px solid hsl(220, 13%, 91%);
    border-radius: 10px;
    font-size: 14px;
    color: hsl(0, 0%, 20%);
    background: #FFFFFF;
    box-sizing: border-box;
    transition: border 0.2s ease, box-shadow 0.2s ease;

    &:focus {
        border-color: hsl(24, 85%, 60%);
        box-shadow: 0px 0px 0px 3px hsla(24, 85%, 60%, 0.25);
        outline: none;
    }
`;

export const PatientSearchResults = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #FFFFFF;
    border: 1px solid hsl(220, 13%, 91%);
    border-top: none;
    border-radius: 0 0 10px 10px;
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.12);
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
`;

export const PatientSearchResultItem = styled.div`
    padding: 12px 14px;
    cursor: pointer;
    border-bottom: 1px solid hsl(220, 13%, 95%);
    transition: background 0.2s ease;

    &:hover {
        background: hsl(210, 40%, 96%);
    }

    &:last-child {
        border-bottom: none;
    }
`;

export const PatientName = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: hsl(0, 0%, 20%);
`;

export const PatientInfo = styled.div`
    font-size: 12px;
    color: hsl(0, 0%, 35%);
    margin-top: 2px;
`;

export const NoResults = styled.div`
    padding: 12px 14px;
    font-size: 14px;
    color: hsl(0, 0%, 35%);
    text-align: center;
`;

export const LoadingSpinner = styled.div`
    padding: 12px 14px;
    font-size: 14px;
    color: hsl(0, 0%, 35%);
    text-align: center;
`;

export const CalendarSelect = styled.select`
    width: 100%;
    padding: 10px 14px;
    border: 1px solid hsl(220, 13%, 91%);
    border-radius: 10px;
    font-size: 14px;
    color: hsl(0, 0%, 20%);
    background: #FFFFFF;
    box-sizing: border-box;
    transition: border 0.2s ease, box-shadow 0.2s ease;
    cursor: pointer;

    &:focus {
        border-color: hsl(24, 85%, 60%);
        box-shadow: 0px 0px 0px 3px hsla(24, 85%, 60%, 0.25);
        outline: none;
    }

    option {
        padding: 8px;
        background: #FFFFFF;
        color: hsl(0, 0%, 20%);
    }
    
    ${media.tablet} {
        padding: 8px 12px;
        font-size: 13px;
        border-radius: 8px;
    }
    
    ${media.mobile} {
        padding: 8px 10px;
        font-size: 12px;
        border-radius: 6px;
    }
`;

export const TurnTypeOptionsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;

    ${media.mobile} {
        grid-template-columns: 1fr;
    }
`;

export const TurnTypeOptionButton = styled.button`
    width: 100%;
    min-height: 54px;
    border-radius: 12px;
    border: 1px solid ${props => props.$active ? 'hsl(24, 85%, 60%)' : 'hsl(220, 13%, 91%)'};
    background: ${props => props.$active ? 'hsl(24, 95%, 96%)' : '#FFFFFF'};
    color: ${props => props.$active ? 'hsl(24, 85%, 40%)' : 'hsl(0, 0%, 25%)'};
    box-shadow: ${props => props.$active ? '0 0 0 3px hsla(24, 85%, 60%, 0.18)' : 'none'};
    padding: 10px 12px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 4px;
    transition: all 0.2s ease;
    box-sizing: border-box;
    text-align: left;

    &:hover {
        border-color: hsl(24, 85%, 60%);
        background: hsl(24, 95%, 97%);
    }
`;

export const TurnTypeOptionTitle = styled.span`
    font-size: 13px;
    font-weight: 800;
    line-height: 1.2;
`;

export const TurnTypeOptionDescription = styled.span`
    font-size: 11px;
    font-weight: 500;
    color: hsl(0, 0%, 45%);
    line-height: 1.25;
`;

export const CurrencyInputContainer = styled.div`
    position: relative;
    width: 100%;
`;

export const CurrencyInput = styled.input`
    width: 100%;
    padding: 10px 14px 10px 30px;
    border: 1px solid hsl(220, 13%, 91%);
    border-radius: 10px;
    font-size: 14px;
    color: hsl(0, 0%, 20%);
    background: #FFFFFF;
    box-sizing: border-box;
    transition: border 0.2s ease, box-shadow 0.2s ease;

    &:focus {
        border-color: hsl(24, 85%, 60%);
        box-shadow: 0px 0px 0px 3px hsla(24, 85%, 60%, 0.25);
        outline: none;
    }
`;

export const CurrencySymbol = styled.span`
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: hsl(0, 0%, 35%);
    font-size: 14px;
    font-weight: 600;
    pointer-events: none;
    z-index: 1;
    
    ${media.tablet} {
        left: 12px;
        font-size: 13px;
    }
    
    ${media.mobile} {
        left: 10px;
        font-size: 12px;
    }
`;

// Estilos para DateInput con validación
export const DateInputWithValidation = styled.input`
    width: 100%;
    padding: 10px 14px;
    border: 1px solid ${props => props.isValid ? 'hsl(220, 13%, 91%)' : '#ef4444'};
    border-radius: 10px;
    font-size: 14px;
    color: hsl(0, 0%, 20%);
    background-color: ${props => props.isValid ? '#FFFFFF' : '#fef2f2'};
    box-sizing: border-box;
    transition: border 0.2s ease, box-shadow 0.2s ease;

    &:focus {
        border-color: hsl(24, 85%, 60%);
        box-shadow: 0px 0px 0px 3px hsla(24, 85%, 60%, 0.25);
        outline: none;
    }
    
    ${media.tablet} {
        padding: 8px 12px;
        font-size: 13px;
        border-radius: 8px;
    }
    
    ${media.mobile} {
        padding: 8px 10px;
        font-size: 12px;
        border-radius: 6px;
    }
`;
